import { render, staticRenderFns } from "./AddMessage.vue?vue&type=template&id=4a64cc10"
import script from "./AddMessage.vue?vue&type=script&lang=js"
export * from "./AddMessage.vue?vue&type=script&lang=js"
import style0 from "./AddMessage.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports